/* eslint-disable prettier/prettier */
import React from "react";

const Start = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.17452 4.48857C5.34409 4.35794 5.43104 4.14686 5.40269 3.9347C5.37434 3.72254 5.23489 3.54172 5.03711 3.46018C4.83919 3.37865 4.61291 3.4089 4.44334 3.53954C3.46784 4.28917 2.75429 5.32788 2.40472 6.5074C2.05501 7.68679 2.08716 8.9466 2.49642 10.1066C2.90569 11.2667 3.67119 12.2677 4.68357 12.9667C5.69595 13.6656 6.90343 14.0266 8.13327 13.9982C9.36312 13.9697 10.5525 13.5533 11.5314 12.8082C12.5104 12.0632 13.2289 11.0278 13.584 9.85001C13.9392 8.67225 13.913 7.4123 13.5091 6.25014C13.1054 5.08812 12.3445 4.08345 11.3355 3.37983C11.2056 3.28501 11.0432 3.24648 10.8846 3.27266C10.7261 3.29898 10.5847 3.38784 10.4923 3.51942C10.3998 3.65087 10.3643 3.81407 10.3933 3.9721C10.4225 4.13014 10.5139 4.26999 10.6471 4.35993C11.7192 5.10915 12.424 6.27728 12.5868 7.57509C12.7496 8.87276 12.3554 10.1789 11.5014 11.1697C10.6476 12.1606 9.41423 12.7435 8.10667 12.7743C6.79896 12.8049 5.53953 12.2803 4.64029 11.3306C3.74092 10.3809 3.28578 9.09491 3.38767 7.79085C3.48941 6.48679 4.13865 5.28692 5.17451 4.48832L5.17452 4.48857Z"
      fill="#539D7E"
    />
    <path
      d="M8.59822 7.3404V2.59903C8.59822 2.38497 8.48414 2.1872 8.29883 2.08027C8.11353 1.97324 7.88509 1.97324 7.69978 2.08027C7.51448 2.18717 7.40039 2.38495 7.40039 2.59903V7.3404C7.40039 7.55433 7.51448 7.75209 7.69978 7.85916C7.88508 7.96605 8.11353 7.96605 8.29883 7.85916C8.48414 7.75213 8.59822 7.55434 8.59822 7.3404Z"
      fill="#539D7E"
    />
  </svg>
);

export default Start;
